/**
 * Regole di default
 * @constant {Object} defaultRule
 */
const defaultRule = {
    required: false,
    email: false,
    equals: {active: false, value: false}
}

/**
 * Classe Rule:
 * Gestione della validazione di un set di regole
 */
class Rule {
    /**
     * Il costruttore ha come parametro un oggetto contente le regole da validare
     * @constructor
     * @param {Object} rules 
     */
    constructor(rules = {}) {
        const keys = Object.keys(defaultRule);
        this.rules = {};
        keys.forEach(key => {
            this.rules[key] = rules[key] || defaultRule[key]; 
        });

        this.setDefaultRuleHandlers();
    }

    /**
     * Applica le regole sul valore passato come parametro
     * @param {*} value
     * @return {Array.<string>} Gli eventuali errori
     */
    apply(value) {
        let errors = [];
        const keys = Object.keys(this.rules);
        for(let ruleName of keys) {
            const check = this.applyRule(ruleName, value);
            if(!check) {
                errors.push(ruleName);
            }
        }
        
        return errors;
    }

    /**
     * Verifica la regola `ruleName` sul valore `value`
     * @param {string} ruleName 
     * @param {*} value
     * @return {boolean}
     */
    applyRule(ruleName, value) {
        let response = true;
        if(this.handlers[ruleName]) {
            for(let handler of this.handlers[ruleName]) {
                response = response && handler.callback(value);
            }
        }
        return response;
    }

    /**
     * Setta gli handler delle regole di default
     */
    setDefaultRuleHandlers() {
        this.handlers = this.handlers ? this.handlers : {};
        this.defaultHandlers = {
            required: this.addHandler('required', this.checkRequired.bind(this)),
            email: this.addHandler('email', this.checkEmail.bind(this)),
            equals: this.addHandler('equals', this.checkEquals.bind(this))
        };
    }

    /**
     * Rimuove un handler di regola
     * @param {string} ruleName 
     * @param {string} handlerUid 
     */
    removeHandler(ruleName, handlerUid) {
        if(this.handlers[ruleName]) {
            this.handlers[ruleName] = this.handlers[ruleName].filter(handler => handler.uid !== handlerUid);
        }
    }

    /**
     * Setta l'handler per la regola di nome `ruleName`
     * @param {string} ruleName 
     * @param {Function} callback 
     */
    addHandler(ruleName, callback) {
        const uid = ruleName + '_' + Date.now() + '_' + Math.round(Math.random() * 100);
        this.handlers[ruleName] = this.handlers[ruleName] || [];
        this.handlers[ruleName].push({uid, callback});
        return uid;
    }

    /**
     * Callback per la regola `required`
     * @param {*} value 
     * @return {boolean}
     */
    checkRequired(value) {
        return !this.rules.required || value !== undefined && value !== null && value !== '';
    }

    /**
     * Callback per la regola `email`
     * @param {string} email
     * @return {boolean} 
     */
    checkEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !this.rules.email || re.test(string(email).toLowerCase());
    }

    /**
     * Callback per la regola `equals`
     * @param {*} value - Il valore da verificare
     * @return {boolean}
     */
    checkEquals(value) {
        if(this.rules.equals && this.rules.equals.active) {
            return this.rules.equals.value === value;
        }

        return true;
    }
}